const STATUS_LABEL = {
  OPEN: "Открыто",
  CLOSED: "Закрыто",
  UPCOMING: "Ожидается",
  DRAFT: "Не задано",
};

export default function Badge({ status }) {
  return (
    <span className={`badge badge-${status.toLowerCase()}`}>
      {STATUS_LABEL[status] ?? "-"}
    </span>
  );
}
